import { Component, inject, OnInit } from '@angular/core';
import { ActivatedRoute, Router }    from '@angular/router';

import { UserSession }          from '../../../../api/session/session.service';
import { DocumentsHelperUtils } from '../../../../shared/utils/documents-helper.utils';

@Component({
  selector: 'pin-documents-access',
  templateUrl: './documents-access.component.html'
})
export class DocumentsAccessComponent implements OnInit {
  private router = inject(Router);
  private activatedRoute = inject(ActivatedRoute);
  userSession: UserSession;

  ngOnInit() {
    this.userSession = this.activatedRoute.snapshot.data.userSession;

    const queryParamMap = this.activatedRoute.snapshot.queryParamMap['params'];
    const statementsEnabled = DocumentsHelperUtils.showStatements(this.userSession) || DocumentsHelperUtils.showCdarsStatements(this.userSession);

    const routeCommands = statementsEnabled ? '/documents/statements' : '/documents/tax-documents';
    this.router.navigate([routeCommands], {queryParams: queryParamMap});
  }
}
